import ProductModal from 'models/Product.modal';
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Button, Card, CardFooter, CardHeader, Container, Input, Row, Table, UncontrolledTooltip } from 'reactstrap';
import AddModal from 'views/components/AddModal';
import TablePagination from 'views/components/TablePagination';
import { helper } from "lib/helper";
import Swal from 'sweetalert2';
import moment from 'moment';
const Productenq = () => {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const parameters = {};
    for (let [key, value] of searchParams) {
      parameters[key] = value;
    }
   
    const [dataList, setDataList] = useState([]);
    //const initialPage = searchParams.get('page') || 1;
    //const [currentPage, setCurrentPage] = useState(parseInt(initialPage, 10) || 1);
   // const [perPage, setPerPage] = useState(20);
    
    
    
    const getListData = async () => {
        setIsLoading(true);
        
        // Dummy data for product enquiries
        const dummyEnquiryData = {
          data: [
            {
              id: "1",
              auth_user: {
                first_name: "Rajesh",
                last_name: "Kumar",
                username: "9876543210"
              },
              product: {
                name: "Mathematics Complete Course - Class 10",
                normal_price: "₹2999",
                discounted_price: "₹1999"
              },
              banner: {
                image: "https://via.placeholder.com/150/0000FF/FFFFFF?text=Math10"
              },
              updatedAt: "2024-01-15T10:30:00Z"
            },
            {
              id: "2",
              auth_user: {
                first_name: "Priya",
                last_name: "Sharma",
                username: "9876543211"
              },
              product: {
                name: "Physics Masterclass - Class 12",
                normal_price: "₹3499",
                discounted_price: "₹2499"
              },
              banner: {
                image: "https://via.placeholder.com/150/FF0000/FFFFFF?text=Phy12"
              },
              updatedAt: "2024-01-16T14:20:00Z"
            },
            {
              id: "3",
              auth_user: {
                first_name: "Amit",
                last_name: "Verma",
                username: "9876543212"
              },
              product: {
                name: "JEE Main Preparation Package",
                normal_price: "₹4999",
                discounted_price: "₹3499"
              },
              banner: {
                image: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=JEE"
              },
              updatedAt: "2024-01-17T09:15:00Z"
            },
            {
              id: "4",
              auth_user: {
                first_name: "Sunita",
                last_name: "Gupta",
                username: "9876543213"
              },
              product: {
                name: "NEET Biology Complete Course",
                normal_price: "₹3999",
                discounted_price: "₹2799"
              },
              banner: {
                image: "https://via.placeholder.com/150/FFFF00/000000?text=NEET"
              },
              updatedAt: "2024-01-18T16:45:00Z"
            },
            {
              id: "5",
              auth_user: {
                first_name: "Vikash",
                last_name: "Singh",
                username: "9876543214"
              },
              product: {
                name: "Chemistry Foundation - Class 11",
                normal_price: "₹2799",
                discounted_price: "₹1899"
              },
              banner: {
                image: "https://via.placeholder.com/150/00FF00/FFFFFF?text=Chem11"
              },
              updatedAt: "2024-01-19T11:30:00Z"
            },
            {
              id: "6",
              auth_user: {
                first_name: "Meera",
                last_name: "Patel",
                username: "9876543215"
              },
              product: {
                name: "English Grammar & Literature - Class 9",
                normal_price: "₹1999",
                discounted_price: "₹1299"
              },
              banner: {
                image: "https://via.placeholder.com/150/800080/FFFFFF?text=Eng9"
              },
              updatedAt: "2024-01-20T13:25:00Z"
            }
          ]
        };
        
        setTimeout(() => {
          setIsLoading(false);
          setDataList(dummyEnquiryData);
        }, 1000);
      };
     

      useEffect(() => {
        getListData();
        //checkApi();
      }, [location]);
      const handleDel = async (delId) => {
        Swal.fire({
          title: 'Are you sure?',
          text: 'Do you really want to delete this enquiry?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            // Simulate delete operation
            setTimeout(() => {
              setDataList(prevData => ({
                ...prevData,
                data: prevData.data.filter(item => item.id !== delId)
              }));
              Swal.fire(
                'Deleted!',
                'The enquiry has been deleted.',
                'success'
              );
            }, 500);
          }
        });
      };

  return (
    <>
      <div className="pt-2 px-4">
        {/* {!isLoading && ( */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Product Enq</h3>

                
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN NO.</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Product Name</th>
                    <th scope="col">Image Banner</th>
                    <th scope="col">Price Normal</th>
                    <th scope="col">Discount price</th>
                    <th scope="col">Added on</th>
                   {/* <th scope="col">Action</th>*/}
                  </tr>
                </thead>
                {!isLoading && (
                  <tbody>
                    {dataList?.data?.length > 0 ? (
                      dataList?.data?.map((item, index) => {
                        
                        return (
                          <tr key={`product${item.id}`} style={{ cursor: "pointer" }}>
                            <td>{ index + 1}</td>
                            <td>
                                <div><div>
                                    {item?.auth_user?.first_name || "-"} {item?.auth_user?.last_name || "-"} </div>
                                    <div>{`(${item?.auth_user?.username})` || "-"}</div>
                                    </div></td>
                            <td>{item?.product?.name || "-"} </td>
                            <td>
                              {item?.banner?.image ? (
                                <img src={item?.banner?.image} height={50} style={{borderRadius:'20%'}} />
                              ):(
                                '-'
                              )}
                            </td>
                            <td>{item?.product?.normal_price || "-"}</td>
                            <td>{item?.product?.discounted_price || "-"}</td>
                            <td>{moment(item?.updatedAt).format('DD-MM-YYYY')|| "-"}</td>

{  /*                          <td
                              className="mt-1"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                // justifyContent: "center",
                                // alignItems: "center",
                              }}
                            >
                              {/*<UncontrolledTooltip
                                placement="top"
                                target="eyeTooltipsoo"
                              >
                                Edit
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="eyeTooltipsoo"
                                to={`/admin/product/editproduct/${item.id}`}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="top"
                                target="userTooltip"
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "10px",
                                  // backgroundColor: "#f5f5f5",
                                  display: "inline-block",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "20%", // Optional: Make it a circle
                                }}
                                id="userTooltip"
                                onClick={() => handleDel(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>*/}
                          </tr>
                        );
                      })
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}


              </Table>
             {/* <CardFooter className="py-4">
                <TablePagination
                 // totalPages={parseInt(dataList?.meta?.total_page ? dataList?.meta?.total_page : 1)}
                  ///currentPage={currentPage}
                 // pageUrl="/admin/product?"
                />
              </CardFooter>*/}
            </Card>
          </div>
        </Row>
        {/* )} */}

        <AddModal
         // modal={modal}
          Name="Add6"
         // toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  )
}

export default Productenq
